<template>
  <div class="center">
    <div>
      <div class="center" v-if="error" style="color: #000">
        <p><b style="color: #ff0000">ERRO AO TENTAR ABRIR A CÂMERA </b></p>
        <p class="f16">
          SEU DISPOSITIVO NÃO PERMITIU ABRIR A CAMERA, CONFIRA SE ELA ESTÁ
          INSTALADA, VOCÊ TAMBEM PODE FAZER SUA INSCRIÇÃO COM UM COMPUTADOR E
          UMA WEBCAM, OU UM CELULAR COM CAMERA, RECOMENDAMOS O NAVEGADOR
          <b>Chrome</b>
          VOCÊ PODE BAIXA-LO E TENTAR NOVAMENTE
        </p>
        <p>
          SE VOCÊ CLICOU PARA NÃO PERMITIR A CAMERA QUANDO A PAGINA INICIOU,
          PODE RECARREGAR ESSA PAGINA PARA ACEITAR NOVAMENTE, OU ENCONTRAR O
          ICONE DE CAMERA NA PARTE SUPERIOR DO NAVEGADOR E ACEITAR A PERMISSÃO
        </p>
      </div>
      <video
        :id="`candidateQuestion${index}`"
        class="video-js vjs-default-skin"
        playsinline
      ></video>
      <div
        v-show="recordStart"
        :class="{ textTimer: timerPlay < 0 ? true : false }"
        class="timerCount"
      >
        {{ timerPlay >= 0 ? timerPlay : "Gravando" }}
      </div>
    </div>
    <div class="control-video">
      <button
        v-if="
          (!isRecord && recruiter) ||
          (!isRecord && timerPlay > 3 && retakers < question.number_retakers)
        "
        @click="startRecord"
        type="button"
        class="btn mt-5 btn-success btn-lg mr-1"
      >
        {{ retakers == 0 ? "COMEÇAR A GRAVAR" : "REGRAVAR RESPOSTA" }}
      </button>

      <button
        v-if="retakers != 0 && !isRecord && timerPlay > 3 && !recruiter"
        type="button"
        class="btn btn-lg mr-1 mt-5 btn-primary"
        @click="nextQuestion"
      >
        ENVIAR VÍDEO
      </button>

      <button
        @click="stopRecord"
        v-if="isRecord"
        class="btn btn-lg mt-5 btn-danger"
      >
        PARAR GRAVAÇÃO
      </button>
    </div>
    <span v-if="!recruiter">
      <span
        v-if="
          retakers != 0 &&
          !isRecord &&
          retakers < question.number_retakers &&
          timerPlay > 3
        "
        class="color-grey"
        >VOCÊ TEM MAIS {{ question.number_retakers - retakers }}
        {{
          question.number_retakers - retakers == 1 ? "TENTATIVA" : "TENTATIVAS"
        }}</span
      >
    </span>
    <div
      v-if="question.choices.canBeEmpty"
    >
      <button @click="nextQuestion(false)" class="btn btn-primary full mt-2">
        Pular
      </button>
    </div>
  </div>
</template>

<script>
import "webrtc-adapter";

import videojs from "video.js";

import Record from "videojs-record/dist/videojs.record.js";
import axios from "axios";
export default {
  props: [
    "question",
    "index",
    "recruiter",
    "job_id",
    "currentTime",
    "is_evaluation"
  ],
  data() {
    return {
      isRecord: false,
      recordStart: false,
      timerStart: "",
      timerPlay: 4,
      player: "",
      retakers: 0,
      error: false,
      loadding: false,
      options: {
        controls: true,
        autoplay: false,
        loop: false,
        fluid: true,
        // width: 540,
        // height: 340,
        controlBar: {
          deviceButton: false,
          recordIndicator: false,
          fullscreenToggle: false,
          volumePanel: false,
          cameraButton: false,
          pipToggle: true,
          recordToggle: false,
        },
        plugins: {
          // configure videojs-record plugin
          record: {
            image: false,
            audio: true,
            video: true,
            pip: true,
            debug: true,
            maxLength: 2,
            videoMimeType: "video/mp4",
          },
        },
      },
    };
  },
  watch: {
    timerPlay(val) {
      if (val == -2) {
        this.recordStart = false;
        clearInterval(this.timerStart);
        this.player.record().start();
        this.timerPlay = 4;
      }
    },
    question() {
      this.player.dispose();
    }
  },
  methods: {
    nextQuestion(show_message = true) {
      if (show_message)
        this.$toast.success("Vídeo enviado com sucesso");
      if(this.is_evaluation){
        this.$emit("nextQuestion", "true");
        return;
      }
      eventBus.$emit("nextQuestion", this.index);
    },
    stopRecord() {
      this.player.record().stop();
      eventBus.$emit("videoRecorded");
    },
    startRecord() {
      this.timerPlay = 3;
      this.retakers++;
      this.recordStart = true;
      this.timerStart = setInterval(() => this.timerPlay--, 1000);
    },
    getThumbnail(player) {
      let canvas = document.createElement("canvas");
      canvas.className = "hide";
      canvas.width = 320;
      canvas.height = 240;
      document.getElementsByTagName("body")[0].appendChild(canvas);

      // draw video frame
      let context = canvas.getContext("2d");
      context.drawImage(
        player.record().mediaElement,
        0,
        0,
        canvas.width,
        canvas.height
      );
      return canvas;
    },
    upload(blob) {
      this.loadding = true;
      let player = blob.recordedData;
      let canvas = this.getThumbnail(blob);
      let formData = new FormData();

      canvas.toBlob((thumb) => {
        if (!this.recruiter) {
          formData.append("answers[thumbnail]", thumb);
          formData.append("answers[video]", player, player.name);
          formData.append("answers[question_id]", this.question.id);
          formData.append("answers[evaluation_id]", this.question.evaluation_id);
          if (this.currentTime) {
            formData.append("answers[time_taken]", this.currentTime);
          }
          axios
            .post("/candidates/answers", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(function (data) {
              // console.log(data);
            })
            .catch(function (error) {
              // console.log(error);
            });
          return;
        }

        let question_current = {};
        question_current.id = this.question.id;
        question_current.title = this.question.title;
        question_current.description = this.question.description;
        question_current.time = this.question.time;
        question_current.number_retakers = this.question.number_retakers;
        question_current.details = this.question.details;
        question_current.job_id = this.question.job_id;
        question_current.video_id = this.question.video_id;
        question_current.selective_process_id = this.question.selective_process_id;

        axios
          .post("/recruiters/questions", {
            questions: {
              job_id: this.job_id,
              itens: [question_current],
            },
          })
          .then((response) => {
            this.question.id = response.data.question.id;
            formData.append("video[thumbnail]", thumb);
            formData.append("video[file]", player, player.name);
            formData.append("video[name]", this.question.title);
            formData.append("video[question_id]", this.question.id);
            formData.append("video[job_id]", this.job_id);
            formData.append("video[recruiter_id]", 0);
            formData.append("video[account_id]", 0);
            axios
              .post("/recruiters/question_videos", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((resp) => {
                this.question.video_id = resp.data.question.video_id;
                this.question.video = resp.data.video;
              })
              .catch(function (error) {
                console.log(error);
              });
          });
        return;
      });
    },
  },
  mounted() {
    if (!this.recruiter) {
      this.options.plugins.record.maxLength = this.question.time + 1;
    } else {
      this.options.plugins.record.maxLength = 180;
    }
    this.player = videojs(
      `#candidateQuestion${this.index}`,
      this.options,
      () => {
        var msg = "";
        videojs.log(msg);
      }
    );

    // this.player.on("deviceReady", () => {
    //   // console.log("device is ready!");
    // });

    // user clicked the record button and started recording
    this.player.on("startRecord", () => {
      this.error = false;
      this.isRecord = true;
      // console.log("started recording!");
    });

    this.player.on("finishRecord", () => {
      this.isRecord = false;
      this.loadding = true;
      this.error = false;
      this.stopRecord();

      this.upload(this.player); //.recordedData, );
    });

    this.player.on("error", (element, error) => {
      console.log(error);
      this.error = true;
      eventBus.$emit("errorCam", true);
    });

    this.player.on("deviceError", () => {
      this.error = true;
      eventBus.$emit("errorCam", true);

      // console.log("device error:", this.player.deviceErrorCode);
    });

    this.player.record().setVideoInput(MediaDeviceInfo.deviceId);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>